const initGloboOptionsCustomization = () => {
    console.log('Globo options customization loaded');

    // Fetch product data for variants
    const fetchProductData = async (productHandle) => {
        try {
            const response = await fetch(`/products/${productHandle}.js`);
            return await response.json();
        } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
        }
    };

    const updateSoldOutOptions = async () => {
        // Fetch product data for the relevant product
        const productHandle = 'lab-diamond-oec'; // Adjust this to match your product handle
        const productData = await fetchProductData(productHandle);

        if (!productData) return;

        // Process dropdown options
        const dropdownItems = document.querySelectorAll('.dropdown-item');

        dropdownItems.forEach((item) => {
            const input = item.querySelector('input[type="radio"]');
            const label = item.querySelector('label');
            const variantTitle = input?.value;

            // Match the variant title from product data
            const variant = productData.variants.find((v) => 
                v.title === variantTitle
            );

            if (variant && !variant.available) {
                // Mark as sold out (disable input and style label)
                item.classList.add('sold-out');
                input.disabled = true;
                label.style.pointerEvents = 'none'; // Prevent interaction
            }
        });
    };

    const moveSelectedValues = () => {
        const optionGroups = document.querySelectorAll('.gpo-element.gpo-form__group');
        optionGroups.forEach(group => {
            const label = group.querySelector('.gpo-label');
            const selectedValues = group.querySelector('.gpo-selected-values');
            const labelIcon = label?.querySelector('.gpo-label__icon');

            if (label && selectedValues && !label.querySelector('.gpo-selected-values')) {
                if (labelIcon) {
                    labelIcon.parentNode.insertBefore(selectedValues, labelIcon);
                } else {
                    label.appendChild(selectedValues);
                }
            }
        });
    };

    const processTextInputs = () => {
        document.querySelectorAll('.gpo-element.gpo-form__group.engraving').forEach(group => {
            if (group.hasAttribute('data-processed')) return;

            const input = group.querySelector('input.gpo-input');
            const label = group.querySelector('.gpo-label');

            if (!input || !label) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'gpo-ov-wrapper horizontal';
            wrapper.style.display = 'none';

            input.parentNode.insertBefore(wrapper, input);
            wrapper.appendChild(input);

            label.style.cursor = 'pointer';
            label.addEventListener('click', () => {
                wrapper.style.display = wrapper.style.display === 'none' ? 'block' : 'none';
                group.classList.toggle('expanded');
            });

            group.setAttribute('data-processed', 'true');
        });
    };

    const processDropdowns = () => {
        document.querySelectorAll('.gpo-element.gpo-form__group').forEach(group => {
            const dropdown = group.querySelector('.gpo-dropdown');
            if (!dropdown || group.hasAttribute('data-dropdown-processed')) return;

            const label = group.querySelector('.gpo-label');
            if (!label) return;

            dropdown.style.display = 'none';
            label.style.cursor = 'pointer';

            label.addEventListener('click', () => {
                dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
                group.classList.toggle('expanded');
            });

            group.setAttribute('data-dropdown-processed', 'true');
        });
    };

    const injectStyles = () => {
        const styles = document.createElement('style');
        styles.textContent = `
            .gpo-label {
                display: flex !important;
                align-items: center !important;
                gap: 8px !important;
                width: 100% !important;
                border-bottom: 2px solid #00239c !important;
            }

            .gpo-selected-values {
                order: 2;
                margin: 0 !important;
                padding: 0 !important;
                font-size: 12px !important;
                text-transform: none !important;
                font-family: OpenSauceOne-Regular !important;
                color: #1e3a8a !important;
                font-weight: normal !important;
                letter-spacing: 0 !important;
            }

            .gpo-label__icon {
                order: 3;
                margin-left: auto !important;
            }

            .gpo-selected-values:not(.has-value) {
                display: none !important;
            }

            .gpo-element:not(.expanded) .gpo-helptext {
                display: none;
            }

            .gpo-app .gpo-element .gpo-label.expanded ~ .gpo-helptext {
                display: block;
            }

            .gpo-element.engraving .gpo-ov-wrapper {
                margin-top: 16px !important;
            }

            .gpo-input {
                width: 100% !important;
                padding: 8px !important;
                border: 1px solid #ccc !important;
                border-radius: 4px !important;
            }

            .gpo-dropdown {
                margin-top: 16px !important;
            }

            /* Sold out styling */
            .dropdown-item.sold-out {
                opacity: 0.5;
                cursor: not-allowed;
                display:none;
            }

            .dropdown-item.sold-out label::after {
                content: " - Sold Out";
                color: #999;
                font-style: italic;
            }

            .dropdown-item.sold-out input {
                pointer-events: none;
            }
        `;
        document.head.appendChild(styles);
    };

    // Initial processing
    injectStyles();
    moveSelectedValues();
    processTextInputs();
    processDropdowns();
    updateSoldOutOptions();

    // Watch for dynamic updates
    const observer = new MutationObserver(() => {
        moveSelectedValues();
        processTextInputs();
        processDropdowns();
        updateSoldOutOptions();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGloboOptionsCustomization);
} else {
    initGloboOptionsCustomization();
}